import React from "react";
import nota from "./nota.guidelines.json";
import { BaseService } from "../../services/BaseService";

export const getRandomArbitrary = (min, max) => {
  const random = Math.random() * (max - min) + min;
  return Math.round(random);
};

export const getDimentionsById = (idDOM) => {
  const currentElement = document.querySelector(idDOM);
  if (!currentElement) return;
  const currentViewport = currentElement.getBoundingClientRect();

  return currentViewport;
};

export const switchPerformanceColor = (color) => {
  switch (color) {
    case "red":
      return nota.color.main.mTwo;
    case "green":
      return nota.color.main.mFour;
    case "yellow":
      return nota.color.main.mThree;
    default:
      return nota.color.main.default;
  }
};

export const elementMatches = (el, selector) => {
  return (el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector).call(el, selector);
};

export const elementMatchesAny = (el, selectorArray) => {
  for (let idx = 0; idx < selectorArray.length; idx++) {
    let v = selectorArray[idx];
    if (elementMatches(el, v) || el.parentElement.closest(v)) {
      return true;
    }
  }
  return false;
};

export const urlExists = (url, callback) => {
  try {
    fetch(url, {
      method: "HEAD",
      cache: "no-cache",
      headers: {
        Authorization: new BaseService().getAuthorization(),
      },
    }).then((response) => {
      callback(response.status === 200);
    });
  } catch (error) {
    callback(false);
  }
};

export const urlExistsAsync = async (url) => {
  try {
    var response = await fetch(url, {
      method: "HEAD",
      cache: "no-cache",
      headers: {
        Authorization: new BaseService().getAuthorization(),
      },
    });
    if (response.status === 200) return true;
  } catch (error) {}
  return false;
};

export const debounce = function (func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

export const downloadBlob = function (blob, filename) {
  var url = window.URL.createObjectURL(blob);
  var a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
};

export const validateEmailFormat = function (val) {
  var regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(val.toLowerCase());
};

export const getByPath = function (path, val) {
  return path.split(".").reduce((p, c) => p?.[c] || null, val);
};

export const waitFor = function (conditionFunction) {
  const poll = (resolve) => {
    if (conditionFunction()) resolve();
    else setTimeout((_) => poll(resolve), 250);
  };

  return new Promise(poll);
};

export const validateNumericEvent = function (e) {
  var key = e.keyCode || e.which;
  if (
    //French AZERTY with Shift
    /^\d$/.test(e.key) ||
    (!e.shiftKey &&
      !e.altKey &&
      !e.ctrlKey &&
      // numbers
      key >= 48 &&
      key <= 57) ||
    // Numeric keypad
    (key >= 96 && key <= 105) ||
    // Backspace and Tab and Enter
    key === 8 ||
    key === 9 ||
    key === 13 ||
    // Home and End
    key === 35 ||
    key === 36 ||
    // left and right arrows
    key === 37 ||
    key === 39 ||
    // up and down arrows
    key === 38 ||
    key === 40 ||
    // Del and Ins
    key === 46 ||
    key === 45
  ) {
    return true;
  } else {
    return false;
  }
};

export const loopItSelf = (arr) => {
  let arrayCopy = [...arr];
  const withoutTheLast = arrayCopy.filter((v, i) => i !== arrayCopy.length - 1);
  const output = [arrayCopy[arrayCopy.length - 1], ...withoutTheLast];

  return output;
};

export const reverseLoopItSelf = (arr) => {
  let arrayCopy = [...arr];
  const withoutTheFirst = arrayCopy.filter((v, i) => i !== 0);
  const output = [...withoutTheFirst, arrayCopy[0]];

  return output;
};

export const isPasswordValid = (pwd) => {
  if (pwd.length < 6) return false;
  if (!/[A-Z]/.test(pwd)) return false;
  if (!/\d/.test(pwd)) return false;

  return true;
};

export const formatNum = (num, separator, fraction, maximumFractionDigits, minimumFractionDigits) => {
  if (num != null && num != undefined) {
    let opt = {};
    if (maximumFractionDigits) opt.maximumFractionDigits = maximumFractionDigits;
    if (minimumFractionDigits) opt.minimumFractionDigits = minimumFractionDigits;
    var str = num.toLocaleString("en-US", opt);
    if (separator !== ",") str = str.replace(/,/g, separator);
    if (fraction !== ".") str = str.replace(/\./, fraction);
    return str;
  }
  return null;
};

export const formatNumDefault = (num, maximumFractionDigits, minimumFractionDigits) => {
  return formatNum(num, " ", ".", maximumFractionDigits, minimumFractionDigits);
};

export const linkifyText = (text) => {
  const urlRegex = /(https?:\/\/[^\s]+)/gi;
  const parts = text.split(urlRegex);

  return parts.map((part, i) => (urlRegex.test(part) ? `<a href="${part}" target="_blank" rel="noopener noreferrer">${part}</a>` : part)).join("");
};
